import { render, staticRenderFns } from "./SubcontractorView.vue?vue&type=template&id=570a8948"
import script from "./SubcontractorView.vue?vue&type=script&lang=js"
export * from "./SubcontractorView.vue?vue&type=script&lang=js"
import style0 from "./SubcontractorView.vue?vue&type=style&index=0&id=570a8948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports